export default __webpack_public_path__ + "static/media/empty_report.01a05bf7.svg";